/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authAreAllQuestionsAnswered } from '../fn/auth/auth-are-all-questions-answered';
import { AuthAreAllQuestionsAnswered$Params } from '../fn/auth/auth-are-all-questions-answered';
import { authDecryptConnectionStrings } from '../fn/auth/auth-decrypt-connection-strings';
import { AuthDecryptConnectionStrings$Params } from '../fn/auth/auth-decrypt-connection-strings';
import { authEndOtherSesssions } from '../fn/auth/auth-end-other-sesssions';
import { AuthEndOtherSesssions$Params } from '../fn/auth/auth-end-other-sesssions';
import { authGetMfaAppSetup } from '../fn/auth/auth-get-mfa-app-setup';
import { AuthGetMfaAppSetup$Params } from '../fn/auth/auth-get-mfa-app-setup';
import { authLicenseCheck } from '../fn/auth/auth-license-check';
import { AuthLicenseCheck$Params } from '../fn/auth/auth-license-check';
import { authRegister } from '../fn/auth/auth-register';
import { AuthRegister$Params } from '../fn/auth/auth-register';
import { authResetAuthApp } from '../fn/auth/auth-reset-auth-app';
import { AuthResetAuthApp$Params } from '../fn/auth/auth-reset-auth-app';
import { authRevokeSession } from '../fn/auth/auth-revoke-session';
import { AuthRevokeSession$Params } from '../fn/auth/auth-revoke-session';
import { authToken } from '../fn/auth/auth-token';
import { AuthToken$Params } from '../fn/auth/auth-token';
import { authValidateAuthAppCode } from '../fn/auth/auth-validate-auth-app-code';
import { AuthValidateAuthAppCode$Params } from '../fn/auth/auth-validate-auth-app-code';
import { authValidateAuthAppCodeWithoutLogin } from '../fn/auth/auth-validate-auth-app-code-without-login';
import { AuthValidateAuthAppCodeWithoutLogin$Params } from '../fn/auth/auth-validate-auth-app-code-without-login';
import { authValidateEmergencyToken } from '../fn/auth/auth-validate-emergency-token';
import { AuthValidateEmergencyToken$Params } from '../fn/auth/auth-validate-emergency-token';
import { authViewConnectionString } from '../fn/auth/auth-view-connection-string';
import { AuthViewConnectionString$Params } from '../fn/auth/auth-view-connection-string';
import { DecryptConnectionStringDto } from '../models/decrypt-connection-string-dto';
import { LicenseRespose } from '../models/license-respose';
import { LoginRespose } from '../models/login-respose';
import { MfaSetup } from '../models/mfa-setup';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authEndOtherSesssions()` */
  static readonly AuthEndOtherSesssionsPath = '/Auth/endOtherSesssions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authEndOtherSesssions()` instead.
   *
   * This method doesn't expect any request body.
   */
  authEndOtherSesssions$Response(params?: AuthEndOtherSesssions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return authEndOtherSesssions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authEndOtherSesssions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authEndOtherSesssions(params?: AuthEndOtherSesssions$Params, context?: HttpContext): Observable<Blob> {
    return this.authEndOtherSesssions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `authLicenseCheck()` */
  static readonly AuthLicenseCheckPath = '/Auth/licenseCheck';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLicenseCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLicenseCheck$Response(params?: AuthLicenseCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseRespose>> {
    return authLicenseCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLicenseCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLicenseCheck(params?: AuthLicenseCheck$Params, context?: HttpContext): Observable<LicenseRespose> {
    return this.authLicenseCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<LicenseRespose>): LicenseRespose => r.body)
    );
  }

  /** Path part for operation `authToken()` */
  static readonly AuthTokenPath = '/Auth/Token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authToken$Response(params: AuthToken$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginRespose>> {
    return authToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authToken(params: AuthToken$Params, context?: HttpContext): Observable<LoginRespose> {
    return this.authToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginRespose>): LoginRespose => r.body)
    );
  }

  /** Path part for operation `authRevokeSession()` */
  static readonly AuthRevokeSessionPath = '/Auth/RevokeSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRevokeSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRevokeSession$Response(params?: AuthRevokeSession$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return authRevokeSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRevokeSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRevokeSession(params?: AuthRevokeSession$Params, context?: HttpContext): Observable<Blob> {
    return this.authRevokeSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `authAreAllQuestionsAnswered()` */
  static readonly AuthAreAllQuestionsAnsweredPath = '/Auth/answers/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authAreAllQuestionsAnswered()` instead.
   *
   * This method doesn't expect any request body.
   */
  authAreAllQuestionsAnswered$Response(params?: AuthAreAllQuestionsAnswered$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return authAreAllQuestionsAnswered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authAreAllQuestionsAnswered$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authAreAllQuestionsAnswered(params?: AuthAreAllQuestionsAnswered$Params, context?: HttpContext): Observable<number> {
    return this.authAreAllQuestionsAnswered$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `authResetAuthApp()` */
  static readonly AuthResetAuthAppPath = '/api/Auth/ResetAuthApp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authResetAuthApp()` instead.
   *
   * This method doesn't expect any request body.
   */
  authResetAuthApp$Response(params?: AuthResetAuthApp$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return authResetAuthApp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authResetAuthApp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authResetAuthApp(params?: AuthResetAuthApp$Params, context?: HttpContext): Observable<string> {
    return this.authResetAuthApp$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `authGetMfaAppSetup()` */
  static readonly AuthGetMfaAppSetupPath = '/api/Auth/GetMFAAppSetup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authGetMfaAppSetup()` instead.
   *
   * This method doesn't expect any request body.
   */
  authGetMfaAppSetup$Response(params?: AuthGetMfaAppSetup$Params, context?: HttpContext): Observable<StrictHttpResponse<MfaSetup>> {
    return authGetMfaAppSetup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authGetMfaAppSetup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authGetMfaAppSetup(params?: AuthGetMfaAppSetup$Params, context?: HttpContext): Observable<MfaSetup> {
    return this.authGetMfaAppSetup$Response(params, context).pipe(
      map((r: StrictHttpResponse<MfaSetup>): MfaSetup => r.body)
    );
  }

  /** Path part for operation `authValidateAuthAppCode()` */
  static readonly AuthValidateAuthAppCodePath = '/api/Auth/ValidateAuthAppCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authValidateAuthAppCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateAuthAppCode$Response(params?: AuthValidateAuthAppCode$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return authValidateAuthAppCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authValidateAuthAppCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateAuthAppCode(params?: AuthValidateAuthAppCode$Params, context?: HttpContext): Observable<Blob> {
    return this.authValidateAuthAppCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `authValidateAuthAppCodeWithoutLogin()` */
  static readonly AuthValidateAuthAppCodeWithoutLoginPath = '/api/Auth/ValidateAuthAppCodeWithoutLogin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authValidateAuthAppCodeWithoutLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateAuthAppCodeWithoutLogin$Response(params?: AuthValidateAuthAppCodeWithoutLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginRespose>> {
    return authValidateAuthAppCodeWithoutLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authValidateAuthAppCodeWithoutLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateAuthAppCodeWithoutLogin(params?: AuthValidateAuthAppCodeWithoutLogin$Params, context?: HttpContext): Observable<LoginRespose> {
    return this.authValidateAuthAppCodeWithoutLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginRespose>): LoginRespose => r.body)
    );
  }

  /** Path part for operation `authValidateEmergencyToken()` */
  static readonly AuthValidateEmergencyTokenPath = '/api/Auth/ValidateEmergencyToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authValidateEmergencyToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateEmergencyToken$Response(params?: AuthValidateEmergencyToken$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return authValidateEmergencyToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authValidateEmergencyToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authValidateEmergencyToken(params?: AuthValidateEmergencyToken$Params, context?: HttpContext): Observable<Blob> {
    return this.authValidateEmergencyToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `authRegister()` */
  static readonly AuthRegisterPath = '/api/Auth/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authRegister$Response(params: AuthRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseRespose>> {
    return authRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authRegister(params: AuthRegister$Params, context?: HttpContext): Observable<LicenseRespose> {
    return this.authRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<LicenseRespose>): LicenseRespose => r.body)
    );
  }

  /** Path part for operation `authViewConnectionString()` */
  static readonly AuthViewConnectionStringPath = '/api/Auth/ViewConnectionString';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authViewConnectionString()` instead.
   *
   * This method doesn't expect any request body.
   */
  authViewConnectionString$Response(params?: AuthViewConnectionString$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return authViewConnectionString(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authViewConnectionString$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authViewConnectionString(params?: AuthViewConnectionString$Params, context?: HttpContext): Observable<string> {
    return this.authViewConnectionString$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `authDecryptConnectionStrings()` */
  static readonly AuthDecryptConnectionStringsPath = '/api/Auth/DecryptConnectionStrings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authDecryptConnectionStrings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authDecryptConnectionStrings$Response(params: AuthDecryptConnectionStrings$Params, context?: HttpContext): Observable<StrictHttpResponse<DecryptConnectionStringDto>> {
    return authDecryptConnectionStrings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authDecryptConnectionStrings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authDecryptConnectionStrings(params: AuthDecryptConnectionStrings$Params, context?: HttpContext): Observable<DecryptConnectionStringDto> {
    return this.authDecryptConnectionStrings$Response(params, context).pipe(
      map((r: StrictHttpResponse<DecryptConnectionStringDto>): DecryptConnectionStringDto => r.body)
    );
  }

}
